import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const useLogout = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const logout = () => {
		const domain = sessionStorage.getItem("DomainDetails");
		// const domain = localStorage.getItem("DomainDetails");

		const tab = localStorage.getItem("tabs");
		sessionStorage.clear();
		if (domain !== null && domain !== undefined) {
			sessionStorage.setItem("DomainDetails", domain);
			// localStorage.setItem("DomainDetails", domain);
		}

		dispatch({ type: "SESSION_RESET" });
		localStorage.clear();
		localStorage.setItem('apiHost',process.env.REACT_APP_API_LOCAL_URL)
		if (tab) {
			localStorage.setItem("tabs", tab);
		}
		navigate("/");
	};

	return [logout];
};

export default useLogout;
